import { clearProfileInfoData, setProfileInfoData, validateProfileInfoData } from './profile_info';
import { setLoading, setGlobalMessage } from '../../app';
import { ALERT_SEVERITY, ERROR_MESSAGES} from 'eebac/constants';
import ApiDataHelper from 'eebac/utils/apiDataHelper';
import ProfileInfoFields from 'eebac/constants/fields/compnay/user/user_profile_info';
import { Catch } from '../../api_exception';
import { setUserBoxProfile } from 'eebac/reducers/userbox_profile';
import { ROUTES_PATH_CONFIG } from 'eebac/config/routes';

const BASE_PATH = "COMPANY_USER_PROFILE";

const setProfileData = (dispatch, profileData) => {
    dispatch(setUserBoxProfile(profileData.userName,
        profileData.userName, false, ROUTES_PATH_CONFIG.COMPANY.profile))

    ApiDataHelper.set(
        (data) => dispatch(setProfileInfoData(data)),
        profileData,
        ProfileInfoFields);
}

export const updateProfile = () =>
    (dispatch, getState, client) => {

        let state = getState();

        dispatch(setLoading(true));
        let apiData = ApiDataHelper.get(state.COMPANY_USER_PROFILE_INFO,
            ProfileInfoFields);

        client.put('/company_user/profile', apiData)
            .then(res => res.data).then(result => {
                dispatch(setLoading(false));
                if (result.isSuccess &&
                    result.data.profile) {
                    dispatch(setGlobalMessage(result.successMessage));
                    setProfileData(dispatch, result.data.profile);

                } else {
                    if (result.data.fieldErrors &&
                        Array.isArray(result.data.fieldErrors)) {
                        dispatch(setProfileInfoData(result.data.fieldErrors))
                    }

                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                }
            }).catch(error => {
                Catch(error, dispatch);
            });
    }

export const validateProfile = () =>
    (dispatch, getState, client) => {
        dispatch(validateProfileInfoData())
    }

export const loadUserProfile = () =>
    (dispatch, getState, client) => {
        dispatch(setLoading(true));
        dispatch(clearProfileInfoData());

        client.get('/company_user/profile').
            then(res => res.data).then(result => {
                dispatch(setLoading(false));
                if (result.isSuccess &&
                    result.data.profile) {
                    setProfileData(dispatch, result.data.profile);
                } else {
                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                }
            }).catch(error => {
                Catch(error, dispatch);
            });
    }

export const PROFILE_FORM_SUBMIT = `${BASE_PATH}/PROFILE_FORM_SUBMIT`;

export const setProfileFormSubmit = (isSubmit) => ({
    type: PROFILE_FORM_SUBMIT,
    isSubmit
});

const initialState = {
    isSubmit: ""
}

export function ProfileFormSubmitReducer(state = { ...initialState }, action) {
    switch (action.type) {
        case PROFILE_FORM_SUBMIT:
            return { ...state, isSubmit: action.isSubmit };
    }

    return state;
}